// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.21.6
// source: common.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import Long from "long";

export const protobufPackage = "com.tick2trade.api.common";

export enum Exchange {
  EXCHANGE_UNKNOWN = 0,
  NSE = 1,
  BSE = 2,
  MCX = 3,
  UNRECOGNIZED = -1,
}

export function exchangeFromJSON(object: any): Exchange {
  switch (object) {
    case 0:
    case "EXCHANGE_UNKNOWN":
      return Exchange.EXCHANGE_UNKNOWN;
    case 1:
    case "NSE":
      return Exchange.NSE;
    case 2:
    case "BSE":
      return Exchange.BSE;
    case 3:
    case "MCX":
      return Exchange.MCX;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Exchange.UNRECOGNIZED;
  }
}

export function exchangeToJSON(object: Exchange): string {
  switch (object) {
    case Exchange.EXCHANGE_UNKNOWN:
      return "EXCHANGE_UNKNOWN";
    case Exchange.NSE:
      return "NSE";
    case Exchange.BSE:
      return "BSE";
    case Exchange.MCX:
      return "MCX";
    case Exchange.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum StandardTimeBucket {
  TIME_BUCKET_UNKNOWN = 0,
  ONE_SECOND = 1,
  FIVE_SECOND = 2,
  TEN_SECOND = 3,
  THIRTY_SECOND = 4,
  ONE_MINUTE = 10,
  THREE_MINUTE = 11,
  FIVE_MINUTE = 12,
  FIFTEEN_MINUTE = 14,
  THIRTY_MINUTE = 15,
  ONE_HOUR = 20,
  ONE_DAY = 30,
  UNRECOGNIZED = -1,
}

export function standardTimeBucketFromJSON(object: any): StandardTimeBucket {
  switch (object) {
    case 0:
    case "TIME_BUCKET_UNKNOWN":
      return StandardTimeBucket.TIME_BUCKET_UNKNOWN;
    case 1:
    case "ONE_SECOND":
      return StandardTimeBucket.ONE_SECOND;
    case 2:
    case "FIVE_SECOND":
      return StandardTimeBucket.FIVE_SECOND;
    case 3:
    case "TEN_SECOND":
      return StandardTimeBucket.TEN_SECOND;
    case 4:
    case "THIRTY_SECOND":
      return StandardTimeBucket.THIRTY_SECOND;
    case 10:
    case "ONE_MINUTE":
      return StandardTimeBucket.ONE_MINUTE;
    case 11:
    case "THREE_MINUTE":
      return StandardTimeBucket.THREE_MINUTE;
    case 12:
    case "FIVE_MINUTE":
      return StandardTimeBucket.FIVE_MINUTE;
    case 14:
    case "FIFTEEN_MINUTE":
      return StandardTimeBucket.FIFTEEN_MINUTE;
    case 15:
    case "THIRTY_MINUTE":
      return StandardTimeBucket.THIRTY_MINUTE;
    case 20:
    case "ONE_HOUR":
      return StandardTimeBucket.ONE_HOUR;
    case 30:
    case "ONE_DAY":
      return StandardTimeBucket.ONE_DAY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StandardTimeBucket.UNRECOGNIZED;
  }
}

export function standardTimeBucketToJSON(object: StandardTimeBucket): string {
  switch (object) {
    case StandardTimeBucket.TIME_BUCKET_UNKNOWN:
      return "TIME_BUCKET_UNKNOWN";
    case StandardTimeBucket.ONE_SECOND:
      return "ONE_SECOND";
    case StandardTimeBucket.FIVE_SECOND:
      return "FIVE_SECOND";
    case StandardTimeBucket.TEN_SECOND:
      return "TEN_SECOND";
    case StandardTimeBucket.THIRTY_SECOND:
      return "THIRTY_SECOND";
    case StandardTimeBucket.ONE_MINUTE:
      return "ONE_MINUTE";
    case StandardTimeBucket.THREE_MINUTE:
      return "THREE_MINUTE";
    case StandardTimeBucket.FIVE_MINUTE:
      return "FIVE_MINUTE";
    case StandardTimeBucket.FIFTEEN_MINUTE:
      return "FIFTEEN_MINUTE";
    case StandardTimeBucket.THIRTY_MINUTE:
      return "THIRTY_MINUTE";
    case StandardTimeBucket.ONE_HOUR:
      return "ONE_HOUR";
    case StandardTimeBucket.ONE_DAY:
      return "ONE_DAY";
    case StandardTimeBucket.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum NotificationChannel {
  NOTIFICATION_CHANNEL_UNKNOWN = 0,
  PUSH_NOTIFICATION = 1,
  EMAIL = 2,
  SMS = 3,
  DESKTOP_POPUP = 4,
  UNRECOGNIZED = -1,
}

export function notificationChannelFromJSON(object: any): NotificationChannel {
  switch (object) {
    case 0:
    case "NOTIFICATION_CHANNEL_UNKNOWN":
      return NotificationChannel.NOTIFICATION_CHANNEL_UNKNOWN;
    case 1:
    case "PUSH_NOTIFICATION":
      return NotificationChannel.PUSH_NOTIFICATION;
    case 2:
    case "EMAIL":
      return NotificationChannel.EMAIL;
    case 3:
    case "SMS":
      return NotificationChannel.SMS;
    case 4:
    case "DESKTOP_POPUP":
      return NotificationChannel.DESKTOP_POPUP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return NotificationChannel.UNRECOGNIZED;
  }
}

export function notificationChannelToJSON(object: NotificationChannel): string {
  switch (object) {
    case NotificationChannel.NOTIFICATION_CHANNEL_UNKNOWN:
      return "NOTIFICATION_CHANNEL_UNKNOWN";
    case NotificationChannel.PUSH_NOTIFICATION:
      return "PUSH_NOTIFICATION";
    case NotificationChannel.EMAIL:
      return "EMAIL";
    case NotificationChannel.SMS:
      return "SMS";
    case NotificationChannel.DESKTOP_POPUP:
      return "DESKTOP_POPUP";
    case NotificationChannel.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ErrorCodes {
  UNKNOWN_EXCEPTION = 0,
  INTERNAL_ERROR = 1,
  DUPLICATE_ENTITY = 2,
  ENTITY_NOT_FOUND = 3,
  ORDER_ERROR = 4,
  RATE_LIMIT_EXCEEDED = 5,
  SDK_ERROR = 6,
  TRADING_ACCOUNT_DISCONNECTED = 7,
  VALIDATION_ERROR = 8,
  ACCESS_DENIED = 9,
  INVALID_ARGUMENT = 10,
  AUTHENTICATION_FAILED = 11,
  PASSWORD_NOT_SET = 12,
  UNRECOGNIZED = -1,
}

export function errorCodesFromJSON(object: any): ErrorCodes {
  switch (object) {
    case 0:
    case "UNKNOWN_EXCEPTION":
      return ErrorCodes.UNKNOWN_EXCEPTION;
    case 1:
    case "INTERNAL_ERROR":
      return ErrorCodes.INTERNAL_ERROR;
    case 2:
    case "DUPLICATE_ENTITY":
      return ErrorCodes.DUPLICATE_ENTITY;
    case 3:
    case "ENTITY_NOT_FOUND":
      return ErrorCodes.ENTITY_NOT_FOUND;
    case 4:
    case "ORDER_ERROR":
      return ErrorCodes.ORDER_ERROR;
    case 5:
    case "RATE_LIMIT_EXCEEDED":
      return ErrorCodes.RATE_LIMIT_EXCEEDED;
    case 6:
    case "SDK_ERROR":
      return ErrorCodes.SDK_ERROR;
    case 7:
    case "TRADING_ACCOUNT_DISCONNECTED":
      return ErrorCodes.TRADING_ACCOUNT_DISCONNECTED;
    case 8:
    case "VALIDATION_ERROR":
      return ErrorCodes.VALIDATION_ERROR;
    case 9:
    case "ACCESS_DENIED":
      return ErrorCodes.ACCESS_DENIED;
    case 10:
    case "INVALID_ARGUMENT":
      return ErrorCodes.INVALID_ARGUMENT;
    case 11:
    case "AUTHENTICATION_FAILED":
      return ErrorCodes.AUTHENTICATION_FAILED;
    case 12:
    case "PASSWORD_NOT_SET":
      return ErrorCodes.PASSWORD_NOT_SET;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ErrorCodes.UNRECOGNIZED;
  }
}

export function errorCodesToJSON(object: ErrorCodes): string {
  switch (object) {
    case ErrorCodes.UNKNOWN_EXCEPTION:
      return "UNKNOWN_EXCEPTION";
    case ErrorCodes.INTERNAL_ERROR:
      return "INTERNAL_ERROR";
    case ErrorCodes.DUPLICATE_ENTITY:
      return "DUPLICATE_ENTITY";
    case ErrorCodes.ENTITY_NOT_FOUND:
      return "ENTITY_NOT_FOUND";
    case ErrorCodes.ORDER_ERROR:
      return "ORDER_ERROR";
    case ErrorCodes.RATE_LIMIT_EXCEEDED:
      return "RATE_LIMIT_EXCEEDED";
    case ErrorCodes.SDK_ERROR:
      return "SDK_ERROR";
    case ErrorCodes.TRADING_ACCOUNT_DISCONNECTED:
      return "TRADING_ACCOUNT_DISCONNECTED";
    case ErrorCodes.VALIDATION_ERROR:
      return "VALIDATION_ERROR";
    case ErrorCodes.ACCESS_DENIED:
      return "ACCESS_DENIED";
    case ErrorCodes.INVALID_ARGUMENT:
      return "INVALID_ARGUMENT";
    case ErrorCodes.AUTHENTICATION_FAILED:
      return "AUTHENTICATION_FAILED";
    case ErrorCodes.PASSWORD_NOT_SET:
      return "PASSWORD_NOT_SET";
    case ErrorCodes.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Platform {
  PLATFORM_UNKNOWN = 0,
  WEB = 1,
  ANDROID = 2,
  IOS = 3,
  WEBSITE = 4,
  UNRECOGNIZED = -1,
}

export function platformFromJSON(object: any): Platform {
  switch (object) {
    case 0:
    case "PLATFORM_UNKNOWN":
      return Platform.PLATFORM_UNKNOWN;
    case 1:
    case "WEB":
      return Platform.WEB;
    case 2:
    case "ANDROID":
      return Platform.ANDROID;
    case 3:
    case "IOS":
      return Platform.IOS;
    case 4:
    case "WEBSITE":
      return Platform.WEBSITE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Platform.UNRECOGNIZED;
  }
}

export function platformToJSON(object: Platform): string {
  switch (object) {
    case Platform.PLATFORM_UNKNOWN:
      return "PLATFORM_UNKNOWN";
    case Platform.WEB:
      return "WEB";
    case Platform.ANDROID:
      return "ANDROID";
    case Platform.IOS:
      return "IOS";
    case Platform.WEBSITE:
      return "WEBSITE";
    case Platform.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Environment {
  ENVIRONMENT_UNKNOWN = 0,
  DEV = 1,
  STAGING = 2,
  PROD = 3,
  UNRECOGNIZED = -1,
}

export function environmentFromJSON(object: any): Environment {
  switch (object) {
    case 0:
    case "ENVIRONMENT_UNKNOWN":
      return Environment.ENVIRONMENT_UNKNOWN;
    case 1:
    case "DEV":
      return Environment.DEV;
    case 2:
    case "STAGING":
      return Environment.STAGING;
    case 3:
    case "PROD":
      return Environment.PROD;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Environment.UNRECOGNIZED;
  }
}

export function environmentToJSON(object: Environment): string {
  switch (object) {
    case Environment.ENVIRONMENT_UNKNOWN:
      return "ENVIRONMENT_UNKNOWN";
    case Environment.DEV:
      return "DEV";
    case Environment.STAGING:
      return "STAGING";
    case Environment.PROD:
      return "PROD";
    case Environment.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum RequestHeader {
  REQUEST_HEADER_UNKNOWN = 0,
  PLATFORM = 1,
  ENVIRONMENT = 2,
  APP_VERSION = 3,
  DEVICE_ID = 4,
  UNRECOGNIZED = -1,
}

export function requestHeaderFromJSON(object: any): RequestHeader {
  switch (object) {
    case 0:
    case "REQUEST_HEADER_UNKNOWN":
      return RequestHeader.REQUEST_HEADER_UNKNOWN;
    case 1:
    case "PLATFORM":
      return RequestHeader.PLATFORM;
    case 2:
    case "ENVIRONMENT":
      return RequestHeader.ENVIRONMENT;
    case 3:
    case "APP_VERSION":
      return RequestHeader.APP_VERSION;
    case 4:
    case "DEVICE_ID":
      return RequestHeader.DEVICE_ID;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RequestHeader.UNRECOGNIZED;
  }
}

export function requestHeaderToJSON(object: RequestHeader): string {
  switch (object) {
    case RequestHeader.REQUEST_HEADER_UNKNOWN:
      return "REQUEST_HEADER_UNKNOWN";
    case RequestHeader.PLATFORM:
      return "PLATFORM";
    case RequestHeader.ENVIRONMENT:
      return "ENVIRONMENT";
    case RequestHeader.APP_VERSION:
      return "APP_VERSION";
    case RequestHeader.DEVICE_ID:
      return "DEVICE_ID";
    case RequestHeader.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface PageRequest {
  pageNumber: number;
  pageSize: number;
}

export interface TimeRange {
  startTime: number;
  endTime: number;
}

export interface TimeBucket {
  timeSeries: TimeBucket_TimeSeries;
  value: number;
}

export enum TimeBucket_TimeSeries {
  TIME_SERIES_UNKNOWN = 0,
  SECOND = 1,
  MINUTE = 2,
  HOUR = 3,
  DAY = 4,
  WEEK = 5,
  MONTH = 6,
  YEAR = 7,
  UNRECOGNIZED = -1,
}

export function timeBucket_TimeSeriesFromJSON(object: any): TimeBucket_TimeSeries {
  switch (object) {
    case 0:
    case "TIME_SERIES_UNKNOWN":
      return TimeBucket_TimeSeries.TIME_SERIES_UNKNOWN;
    case 1:
    case "SECOND":
      return TimeBucket_TimeSeries.SECOND;
    case 2:
    case "MINUTE":
      return TimeBucket_TimeSeries.MINUTE;
    case 3:
    case "HOUR":
      return TimeBucket_TimeSeries.HOUR;
    case 4:
    case "DAY":
      return TimeBucket_TimeSeries.DAY;
    case 5:
    case "WEEK":
      return TimeBucket_TimeSeries.WEEK;
    case 6:
    case "MONTH":
      return TimeBucket_TimeSeries.MONTH;
    case 7:
    case "YEAR":
      return TimeBucket_TimeSeries.YEAR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TimeBucket_TimeSeries.UNRECOGNIZED;
  }
}

export function timeBucket_TimeSeriesToJSON(object: TimeBucket_TimeSeries): string {
  switch (object) {
    case TimeBucket_TimeSeries.TIME_SERIES_UNKNOWN:
      return "TIME_SERIES_UNKNOWN";
    case TimeBucket_TimeSeries.SECOND:
      return "SECOND";
    case TimeBucket_TimeSeries.MINUTE:
      return "MINUTE";
    case TimeBucket_TimeSeries.HOUR:
      return "HOUR";
    case TimeBucket_TimeSeries.DAY:
      return "DAY";
    case TimeBucket_TimeSeries.WEEK:
      return "WEEK";
    case TimeBucket_TimeSeries.MONTH:
      return "MONTH";
    case TimeBucket_TimeSeries.YEAR:
      return "YEAR";
    case TimeBucket_TimeSeries.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface OptionGreeks {
  delta: number;
  gamma: number;
  vega: number;
  theta: number;
  rho: number;
}

export interface Indicator {
  exchange: Exchange;
  securityCode: string;
  indicatorCode: string;
}

export interface Expiry {
  date: string;
  expiry: number;
  numberOfDaysToExpiry: number;
  weeklyExpiry: boolean;
  name: string;
}

export interface Change {
  timeBucket: TimeBucket | undefined;
  value: number;
  change: number;
  changePercent: number;
}

export interface ErrorResponse {
  errorCode: string;
  message: string;
}

export interface SortBy {
  field: string;
  direction: SortBy_Direction;
}

export enum SortBy_Direction {
  UNKNOWN = 0,
  ASC = 1,
  DESC = 2,
  UNRECOGNIZED = -1,
}

export function sortBy_DirectionFromJSON(object: any): SortBy_Direction {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return SortBy_Direction.UNKNOWN;
    case 1:
    case "ASC":
      return SortBy_Direction.ASC;
    case 2:
    case "DESC":
      return SortBy_Direction.DESC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SortBy_Direction.UNRECOGNIZED;
  }
}

export function sortBy_DirectionToJSON(object: SortBy_Direction): string {
  switch (object) {
    case SortBy_Direction.UNKNOWN:
      return "UNKNOWN";
    case SortBy_Direction.ASC:
      return "ASC";
    case SortBy_Direction.DESC:
      return "DESC";
    case SortBy_Direction.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Params {
  key: string;
  value: string;
}

function createBasePageRequest(): PageRequest {
  return { pageNumber: 0, pageSize: 0 };
}

export const PageRequest = {
  encode(message: PageRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.pageNumber !== 0) {
      writer.uint32(8).int32(message.pageNumber);
    }
    if (message.pageSize !== 0) {
      writer.uint32(16).int32(message.pageSize);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PageRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.pageNumber = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PageRequest {
    return {
      pageNumber: isSet(object.pageNumber) ? globalThis.Number(object.pageNumber) : 0,
      pageSize: isSet(object.pageSize) ? globalThis.Number(object.pageSize) : 0,
    };
  },

  toJSON(message: PageRequest): unknown {
    const obj: any = {};
    if (message.pageNumber !== 0) {
      obj.pageNumber = Math.round(message.pageNumber);
    }
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PageRequest>, I>>(base?: I): PageRequest {
    return PageRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PageRequest>, I>>(object: I): PageRequest {
    const message = createBasePageRequest();
    message.pageNumber = object.pageNumber ?? 0;
    message.pageSize = object.pageSize ?? 0;
    return message;
  },
};

function createBaseTimeRange(): TimeRange {
  return { startTime: 0, endTime: 0 };
}

export const TimeRange = {
  encode(message: TimeRange, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.startTime !== 0) {
      writer.uint32(8).int64(message.startTime);
    }
    if (message.endTime !== 0) {
      writer.uint32(16).int64(message.endTime);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TimeRange {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimeRange();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.startTime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.endTime = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TimeRange {
    return {
      startTime: isSet(object.startTime) ? globalThis.Number(object.startTime) : 0,
      endTime: isSet(object.endTime) ? globalThis.Number(object.endTime) : 0,
    };
  },

  toJSON(message: TimeRange): unknown {
    const obj: any = {};
    if (message.startTime !== 0) {
      obj.startTime = Math.round(message.startTime);
    }
    if (message.endTime !== 0) {
      obj.endTime = Math.round(message.endTime);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TimeRange>, I>>(base?: I): TimeRange {
    return TimeRange.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TimeRange>, I>>(object: I): TimeRange {
    const message = createBaseTimeRange();
    message.startTime = object.startTime ?? 0;
    message.endTime = object.endTime ?? 0;
    return message;
  },
};

function createBaseTimeBucket(): TimeBucket {
  return { timeSeries: 0, value: 0 };
}

export const TimeBucket = {
  encode(message: TimeBucket, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.timeSeries !== 0) {
      writer.uint32(8).int32(message.timeSeries);
    }
    if (message.value !== 0) {
      writer.uint32(16).int32(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TimeBucket {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimeBucket();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.timeSeries = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.value = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TimeBucket {
    return {
      timeSeries: isSet(object.timeSeries) ? timeBucket_TimeSeriesFromJSON(object.timeSeries) : 0,
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: TimeBucket): unknown {
    const obj: any = {};
    if (message.timeSeries !== 0) {
      obj.timeSeries = timeBucket_TimeSeriesToJSON(message.timeSeries);
    }
    if (message.value !== 0) {
      obj.value = Math.round(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TimeBucket>, I>>(base?: I): TimeBucket {
    return TimeBucket.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TimeBucket>, I>>(object: I): TimeBucket {
    const message = createBaseTimeBucket();
    message.timeSeries = object.timeSeries ?? 0;
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseOptionGreeks(): OptionGreeks {
  return { delta: 0, gamma: 0, vega: 0, theta: 0, rho: 0 };
}

export const OptionGreeks = {
  encode(message: OptionGreeks, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.delta !== 0) {
      writer.uint32(13).float(message.delta);
    }
    if (message.gamma !== 0) {
      writer.uint32(21).float(message.gamma);
    }
    if (message.vega !== 0) {
      writer.uint32(29).float(message.vega);
    }
    if (message.theta !== 0) {
      writer.uint32(37).float(message.theta);
    }
    if (message.rho !== 0) {
      writer.uint32(45).float(message.rho);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OptionGreeks {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOptionGreeks();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.delta = reader.float();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.gamma = reader.float();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.vega = reader.float();
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.theta = reader.float();
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.rho = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OptionGreeks {
    return {
      delta: isSet(object.delta) ? globalThis.Number(object.delta) : 0,
      gamma: isSet(object.gamma) ? globalThis.Number(object.gamma) : 0,
      vega: isSet(object.vega) ? globalThis.Number(object.vega) : 0,
      theta: isSet(object.theta) ? globalThis.Number(object.theta) : 0,
      rho: isSet(object.rho) ? globalThis.Number(object.rho) : 0,
    };
  },

  toJSON(message: OptionGreeks): unknown {
    const obj: any = {};
    if (message.delta !== 0) {
      obj.delta = message.delta;
    }
    if (message.gamma !== 0) {
      obj.gamma = message.gamma;
    }
    if (message.vega !== 0) {
      obj.vega = message.vega;
    }
    if (message.theta !== 0) {
      obj.theta = message.theta;
    }
    if (message.rho !== 0) {
      obj.rho = message.rho;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OptionGreeks>, I>>(base?: I): OptionGreeks {
    return OptionGreeks.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OptionGreeks>, I>>(object: I): OptionGreeks {
    const message = createBaseOptionGreeks();
    message.delta = object.delta ?? 0;
    message.gamma = object.gamma ?? 0;
    message.vega = object.vega ?? 0;
    message.theta = object.theta ?? 0;
    message.rho = object.rho ?? 0;
    return message;
  },
};

function createBaseIndicator(): Indicator {
  return { exchange: 0, securityCode: "", indicatorCode: "" };
}

export const Indicator = {
  encode(message: Indicator, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange);
    }
    if (message.securityCode !== "") {
      writer.uint32(18).string(message.securityCode);
    }
    if (message.indicatorCode !== "") {
      writer.uint32(26).string(message.indicatorCode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Indicator {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIndicator();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.exchange = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.securityCode = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.indicatorCode = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Indicator {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      securityCode: isSet(object.securityCode) ? globalThis.String(object.securityCode) : "",
      indicatorCode: isSet(object.indicatorCode) ? globalThis.String(object.indicatorCode) : "",
    };
  },

  toJSON(message: Indicator): unknown {
    const obj: any = {};
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange);
    }
    if (message.securityCode !== "") {
      obj.securityCode = message.securityCode;
    }
    if (message.indicatorCode !== "") {
      obj.indicatorCode = message.indicatorCode;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Indicator>, I>>(base?: I): Indicator {
    return Indicator.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Indicator>, I>>(object: I): Indicator {
    const message = createBaseIndicator();
    message.exchange = object.exchange ?? 0;
    message.securityCode = object.securityCode ?? "";
    message.indicatorCode = object.indicatorCode ?? "";
    return message;
  },
};

function createBaseExpiry(): Expiry {
  return { date: "", expiry: 0, numberOfDaysToExpiry: 0, weeklyExpiry: false, name: "" };
}

export const Expiry = {
  encode(message: Expiry, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.date !== "") {
      writer.uint32(10).string(message.date);
    }
    if (message.expiry !== 0) {
      writer.uint32(16).int64(message.expiry);
    }
    if (message.numberOfDaysToExpiry !== 0) {
      writer.uint32(24).int32(message.numberOfDaysToExpiry);
    }
    if (message.weeklyExpiry !== false) {
      writer.uint32(32).bool(message.weeklyExpiry);
    }
    if (message.name !== "") {
      writer.uint32(42).string(message.name);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Expiry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExpiry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.date = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.expiry = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.numberOfDaysToExpiry = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.weeklyExpiry = reader.bool();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.name = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Expiry {
    return {
      date: isSet(object.date) ? globalThis.String(object.date) : "",
      expiry: isSet(object.expiry) ? globalThis.Number(object.expiry) : 0,
      numberOfDaysToExpiry: isSet(object.numberOfDaysToExpiry) ? globalThis.Number(object.numberOfDaysToExpiry) : 0,
      weeklyExpiry: isSet(object.weeklyExpiry) ? globalThis.Boolean(object.weeklyExpiry) : false,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
    };
  },

  toJSON(message: Expiry): unknown {
    const obj: any = {};
    if (message.date !== "") {
      obj.date = message.date;
    }
    if (message.expiry !== 0) {
      obj.expiry = Math.round(message.expiry);
    }
    if (message.numberOfDaysToExpiry !== 0) {
      obj.numberOfDaysToExpiry = Math.round(message.numberOfDaysToExpiry);
    }
    if (message.weeklyExpiry !== false) {
      obj.weeklyExpiry = message.weeklyExpiry;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Expiry>, I>>(base?: I): Expiry {
    return Expiry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Expiry>, I>>(object: I): Expiry {
    const message = createBaseExpiry();
    message.date = object.date ?? "";
    message.expiry = object.expiry ?? 0;
    message.numberOfDaysToExpiry = object.numberOfDaysToExpiry ?? 0;
    message.weeklyExpiry = object.weeklyExpiry ?? false;
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseChange(): Change {
  return { timeBucket: undefined, value: 0, change: 0, changePercent: 0 };
}

export const Change = {
  encode(message: Change, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.timeBucket !== undefined) {
      TimeBucket.encode(message.timeBucket, writer.uint32(10).fork()).ldelim();
    }
    if (message.value !== 0) {
      writer.uint32(25).double(message.value);
    }
    if (message.change !== 0) {
      writer.uint32(41).double(message.change);
    }
    if (message.changePercent !== 0) {
      writer.uint32(57).double(message.changePercent);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Change {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChange();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.timeBucket = TimeBucket.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.value = reader.double();
          continue;
        case 5:
          if (tag !== 41) {
            break;
          }

          message.change = reader.double();
          continue;
        case 7:
          if (tag !== 57) {
            break;
          }

          message.changePercent = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Change {
    return {
      timeBucket: isSet(object.timeBucket) ? TimeBucket.fromJSON(object.timeBucket) : undefined,
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
      change: isSet(object.change) ? globalThis.Number(object.change) : 0,
      changePercent: isSet(object.changePercent) ? globalThis.Number(object.changePercent) : 0,
    };
  },

  toJSON(message: Change): unknown {
    const obj: any = {};
    if (message.timeBucket !== undefined) {
      obj.timeBucket = TimeBucket.toJSON(message.timeBucket);
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    if (message.change !== 0) {
      obj.change = message.change;
    }
    if (message.changePercent !== 0) {
      obj.changePercent = message.changePercent;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Change>, I>>(base?: I): Change {
    return Change.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Change>, I>>(object: I): Change {
    const message = createBaseChange();
    message.timeBucket = (object.timeBucket !== undefined && object.timeBucket !== null)
      ? TimeBucket.fromPartial(object.timeBucket)
      : undefined;
    message.value = object.value ?? 0;
    message.change = object.change ?? 0;
    message.changePercent = object.changePercent ?? 0;
    return message;
  },
};

function createBaseErrorResponse(): ErrorResponse {
  return { errorCode: "", message: "" };
}

export const ErrorResponse = {
  encode(message: ErrorResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.errorCode !== "") {
      writer.uint32(10).string(message.errorCode);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ErrorResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseErrorResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.errorCode = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ErrorResponse {
    return {
      errorCode: isSet(object.errorCode) ? globalThis.String(object.errorCode) : "",
      message: isSet(object.message) ? globalThis.String(object.message) : "",
    };
  },

  toJSON(message: ErrorResponse): unknown {
    const obj: any = {};
    if (message.errorCode !== "") {
      obj.errorCode = message.errorCode;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ErrorResponse>, I>>(base?: I): ErrorResponse {
    return ErrorResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ErrorResponse>, I>>(object: I): ErrorResponse {
    const message = createBaseErrorResponse();
    message.errorCode = object.errorCode ?? "";
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseSortBy(): SortBy {
  return { field: "", direction: 0 };
}

export const SortBy = {
  encode(message: SortBy, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.field !== "") {
      writer.uint32(10).string(message.field);
    }
    if (message.direction !== 0) {
      writer.uint32(16).int32(message.direction);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SortBy {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSortBy();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.field = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.direction = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SortBy {
    return {
      field: isSet(object.field) ? globalThis.String(object.field) : "",
      direction: isSet(object.direction) ? sortBy_DirectionFromJSON(object.direction) : 0,
    };
  },

  toJSON(message: SortBy): unknown {
    const obj: any = {};
    if (message.field !== "") {
      obj.field = message.field;
    }
    if (message.direction !== 0) {
      obj.direction = sortBy_DirectionToJSON(message.direction);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SortBy>, I>>(base?: I): SortBy {
    return SortBy.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SortBy>, I>>(object: I): SortBy {
    const message = createBaseSortBy();
    message.field = object.field ?? "";
    message.direction = object.direction ?? 0;
    return message;
  },
};

function createBaseParams(): Params {
  return { key: "", value: "" };
}

export const Params = {
  encode(message: Params, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Params {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Params {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: Params): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Params>, I>>(base?: I): Params {
    return Params.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Params>, I>>(object: I): Params {
    const message = createBaseParams();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
